export default __webpack_public_path__ + "07780db8272ceb247d640286c17caebf.svg";